"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDashboardDataProvider = exports.dashboardStickinessChunksParameters = exports.dashboardRetentionChunksParameters = exports.calculateNewUsersFeatureState = exports.calculateActiveUsersFeatureState = exports.useProjectDashboardDataContext = exports.testDashboardData = exports.D_Stickiness = exports.D_Lifecycle_Daily = exports.D_Lifecycle_Weekly = exports.D_Retention = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const lodash_1 = __importDefault(require("lodash"));
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const use_custom_compare_1 = require("use-custom-compare");
const RetentionApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionApiService");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const LifecycleApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecycleApiService");
const DashboardApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/DashboardApiService");
const DashboardConstants_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/DashboardConstants");
const StickinessApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessApiService");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const EventApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventApiService");
const LifecycleGranularityJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleGranularityJSONModel");
const AggregationJSONModel_1 = require("src/hello_assets/src/components/model/common/AggregationJSONModel");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
/*

errors.js:7 Uncaught (in promise) Error: Call failed:
  Canister: 5rpft-oqaaa-aaaah-qaa5a-cai
  Method: getProjectActiveUsersLastD7 (query)
  "Status": "rejected"
  "Code": "DestinationInvalid"
  "Message": "IC0302: Canister 5rpft-oqaaa-aaaah-qaa5a-cai has no query method 'getProjectActiveUsersLastD7'"
    at actor.js:158
    at async CurrentProjectDataProvider.tsx:77

* */
const isFakeData = process.env.NODE_ENV === "development" && false;
const testIntervalStartTimeSec = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDayEndOf().subtract(DashboardConstants_1.DASHBOARD_LAST_N_DAYS, "day").valueOf() / 1000;
const D = {
    dau: {
        data: Int32Array.from([5633, 1168, 3545, 2823, 5461, 5295, 5291, 552, 1512, 2, 3289, 0, 0, 0, 0, 0, 0, 1571, 1471, 1514, 1498, 1630, 1711, 1352, 1468, 1334, 1358, 1200, 2811, 1737]),
        intervalStartTimeSec: 1635060060
    },
    mau: {
        data: Int32Array.from([14787, 14901, 15028, 15286, 15439, 15487, 15487, 15488, 15488, 15489, 15489, 15489, 15489, 15456, 15040, 14593, 14321, 14400, 14233, 14335, 14157, 14115, 14093, 13793, 13835, 13810, 13706, 13640, 13821, 13777]),
        intervalStartTimeSec: 1635060060
    },
    wau: {
        data: Int32Array.from([9192, 9024, 8813, 8572, 8313, 7978, 7688, 7421, 7140, 6783, 6273, 5593, 5388, 4131, 4125, 3291, 3289, 1571, 2435, 3093, 3696, 4234, 4810, 5190, 5023, 5033, 5047, 4911, 6378, 6126]),
        intervalStartTimeSec: 1635060060
    },
    projectUsers: 20049,
    newUsers: {
        data: Int32Array.from([158, 114, 127, 258, 153, 48, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 808, 431, 393, 397, 392, 368, 269, 281, 223, 258, 250, 389, 101]),
        intervalStartTimeSec: 1635060060
    },
};
exports.D_Retention = {
    retentionPeriods: Uint32Array.from([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]),
    retention: Array.from([[140, 140, 20, 14, 11, 7, 8, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 7, 8, 4, 9, 8, 31, 1, 5, 5, 7, 8, 6], [158, 158, 35, 15, 23, 30, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 8, 9, 3, 8, 1, 17, 10, 1, 10, 3, 12, 7], [114, 114, 12, 12, 17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 2, 5, 6, 9, 3, 7, 9, 4, 8, 3, 3, 0], [127, 127, 11, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 2, 2, 11, 7, 4, 9, 1, 7, 0, 2, 1], [258, 258, 14, 3, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 8, 8, 7, 12, 5, 7, 8, 4, 5, 8, 5, 3], [153, 153, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 8, 11, 9, 5, 6, 5, 7, 4, 10, 3, 2, 3], [48, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 0, 1, 0, 2, 0, 0, 0], [], [1, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [], [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [], [], [], [], [], [], [], [808, 808, 227, 240, 199, 269, 168, 145, 242, 203, 170, 111, 117, 42], [431, 431, 145, 135, 130, 130, 81, 57, 64, 50, 47, 39, 43], [393, 393, 94, 71, 56, 62, 45, 50, 46, 41, 42, 13], [397, 397, 51, 54, 29, 33, 32, 29, 33, 19, 5], [392, 392, 65, 36, 38, 26, 27, 22, 27, 6], [368, 368, 76, 70, 55, 46, 67, 58, 53], [269, 269, 22, 10, 14, 10, 7, 3], [281, 281, 37, 15, 29, 17, 9], [223, 223, 25, 15, 11, 12], [258, 258, 23, 24, 6], [250, 250, 60, 17], [389, 389, 26], [],], v => Int32Array.from(v)),
    intervalStartTimeSec: testIntervalStartTimeSec
};
exports.D_Lifecycle_Weekly = {
    intervalStartTimeSec: 1635060392,
    rawData: {
        churnedUsersCohort: Int32Array.from([12035, 11371, 10909, 10711, 10293, 10066, 9730, 9192, 9024, 8813, 8572, 8313, 7978, 7688, 7421, 7140, 6783, 6273, 5593, 5388, 4131, 4125, 3291, 3289, 1571, 2435, 3093, 3696, 4234, 4810]),
        resurrectedUsers: Int32Array.from([152, 237, 289, 336, 340, 296, 272, 243, 200, 121, 68, 14, 2, 2, 1, 1, 0, 533, 1140, 1460, 1667, 1813, 2021, 2132, 1425, 1059, 882, 757, 2097, 2140]),
        newUsers: Int32Array.from([1398, 1332, 1190, 1227, 1155, 998, 858, 701, 587, 461, 203, 50, 2, 2, 1, 1, 0, 808, 1239, 1632, 2029, 2421, 2789, 3058, 2531, 2323, 2188, 2041, 2038, 1775]),
        churnedUsers: Int32Array.from([4393, 3916, 3575, 3702, 3475, 3382, 3172, 2715, 2671, 2612, 2570, 2784, 2594, 3561, 3298, 3851, 3494, 6043, 5537, 5387, 4131, 4125, 3291, 3289, 504, 784, 1116, 1583, 1991, 2589]),
        currentUsers: Int32Array.from([7642, 7455, 7334, 7009, 6818, 6684, 6558, 6477, 6353, 6201, 6002, 5529, 5384, 4127, 4123, 3289, 3289, 230, 56, 1, 0, 0, 0, 0, 1067, 1651, 1977, 2113, 2243, 2221]),
    }
};
exports.D_Lifecycle_Daily = {
    intervalStartTimeSec: 1635060476,
    rawData: {
        churnedUsersCohort: Int32Array.from([6202, 5633, 1168, 3545, 2823, 5461, 5295, 5291, 552, 1512, 2, 3289, 0, 0, 0, 0, 0, 0, 1571, 1471, 1514, 1498, 1630, 1711, 1352, 1468, 1334, 1358, 1200, 2811]),
        resurrectedUsers: Int32Array.from([312, 460, 2983, 1653, 3665, 691, 293, 17, 1511, 1, 3289, 0, 0, 0, 0, 0, 0, 763, 433, 500, 464, 540, 592, 408, 587, 473, 576, 436, 1809, 396]),
        newUsers: Int32Array.from([158, 114, 127, 258, 153, 48, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 808, 431, 393, 397, 392, 368, 269, 281, 223, 258, 250, 389, 105]),
        churnedUsers: Int32Array.from([1039, 5039, 733, 2633, 1180, 905, 297, 4757, 551, 1512, 2, 3289, 0, 0, 0, 0, 0, 0, 964, 850, 877, 800, 879, 1036, 752, 830, 810, 844, 587, 1548]),
        currentUsers: Int32Array.from([5163, 594, 435, 912, 1643, 4556, 4998, 534, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 607, 621, 637, 698, 751, 675, 600, 638, 524, 514, 613, 1263]),
    }
};
exports.D_Stickiness = {
    chartData: Array.from([[2302, 623, 324, 501, 1191, 3949, 302], [2244, 553, 511, 1104, 4084, 347, 181], [2113, 586, 804, 2237, 2700, 217, 156], [1906, 550, 753, 2114, 2704, 391, 154], [1707, 537, 581, 2030, 2881, 443, 134], [1525, 438, 502, 1994, 2912, 565, 42], [1370, 390, 517, 1969, 3031, 393, 18], [0, 0, 0, 0, 0, 0, 0], [1252, 405, 1326, 2774, 1479, 180, 5], [1153, 394, 1437, 2672, 1376, 110, 0], [972, 339, 1387, 2285, 1527, 273, 0], [761, 219, 1876, 2511, 906, 0, 0], [216, 1520, 2744, 1113, 0, 0, 0], [1334, 2851, 1203, 0, 0, 0, 0], [2908, 1223, 0, 0, 0, 0, 0], [3291, 0, 0, 0, 0, 0, 0], [3289, 0, 0, 0, 0, 0, 0], [1571, 0, 0, 0, 0, 0, 0], [1828, 607, 0, 0, 0, 0, 0], [2015, 693, 385, 0, 0, 0, 0], [2318, 684, 408, 286, 0, 0, 0], [2591, 653, 427, 309, 254, 0, 0], [2853, 756, 421, 350, 213, 217, 0], [3028, 796, 426, 410, 165, 171, 194], [2849, 791, 435, 425, 142, 169, 212], [2902, 759, 545, 270, 196, 135, 226], [2993, 747, 482, 302, 142, 167, 214], [2952, 730, 445, 214, 185, 170, 215], [4516, 779, 345, 193, 135, 192, 218], [3567, 1612, 308, 161, 138, 227, 126]], v => Int32Array.from(v)),
    periods: Uint32Array.from([1, 2, 3, 4, 5, 6, 7]),
    intervalStartTimeSec: 1634974158
};
exports.testDashboardData = {
    dau: D.dau,
    projectUsers: D.projectUsers,
    wau: D.wau,
    mau: D.wau,
    newUsers: D.newUsers,
};
const testRetentionData = exports.D_Retention;
const testLifecycleDataDaily = exports.D_Lifecycle_Daily;
const CurrentProjectDataContext = React.createContext({});
const useProjectDashboardDataContext = () => React.useContext(CurrentProjectDataContext);
exports.useProjectDashboardDataContext = useProjectDashboardDataContext;
const initialState = {
    loaded: false,
    inProgress: false,
    error: undefined,
    isError: false,
    data: undefined
};
const calculateActiveUsersFeatureState = (dashboardFeatureState) => {
    if (!dashboardFeatureState.isError && dashboardFeatureState.state) {
        const dau = dashboardFeatureState.state.dau;
        const wau = dashboardFeatureState.state.wau;
        const mau = dashboardFeatureState.state.mau;
        return {
            isError: false,
            error: undefined,
            state: {
                dau: dau,
                wau: wau,
                mau: mau
            }
        };
    }
    else {
        return {
            isError: true,
            error: dashboardFeatureState.error,
            state: undefined
        };
    }
};
exports.calculateActiveUsersFeatureState = calculateActiveUsersFeatureState;
const calculateNewUsersFeatureState = (dashboardFeatureState) => {
    if (!dashboardFeatureState.isError && dashboardFeatureState.state) {
        const newUsers = dashboardFeatureState.state.newUsers;
        const newUsersCumulative = {
            data: Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.cumulative(Array.from(newUsers === null || newUsers === void 0 ? void 0 : newUsers.data))),
            intervalStartTimeSec: newUsers.intervalStartTimeSec
        };
        //get last cumulative value and subtract it from "total project users count" - it will be the value to sum with all points on a chart
        //our goal is to get last cumulative point to be the same as "total project users count"
        const lastCumulativeValue = lodash_1.default.last(newUsersCumulative.data) || 0;
        const numberToAddToCumulativeArrayValues = dashboardFeatureState.state.projectUsers - lastCumulativeValue;
        if (numberToAddToCumulativeArrayValues > 0) {
            newUsersCumulative.data = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.add(Array.from(newUsersCumulative.data), numberToAddToCumulativeArrayValues));
        }
        return {
            isError: false,
            error: undefined,
            state: {
                newUsers: newUsers,
                newUsersCumulative: newUsersCumulative
            }
        };
    }
    else {
        return {
            isError: true,
            error: dashboardFeatureState.error,
            state: undefined
        };
    }
};
exports.calculateNewUsersFeatureState = calculateNewUsersFeatureState;
const calculateStatsFeatureState = (dashboardFeatureState) => {
    if (!dashboardFeatureState.isError && dashboardFeatureState.state) {
        const totalUsers = dashboardFeatureState.state.projectUsers;
        const dau = dashboardFeatureState.state.dau;
        const wau = dashboardFeatureState.state.wau;
        const dauToday = lodash_1.default.last(dau.data) || 0;
        const dauThisWeek = lodash_1.default.last(wau.data) || 0;
        const newUsers = dashboardFeatureState.state.newUsers;
        const newUsersToday = lodash_1.default.last(newUsers === null || newUsers === void 0 ? void 0 : newUsers.data) || 0;
        const newUsersThisWeek = ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumOfNElementsRight(Array.from(newUsers.data), 7);
        return {
            isError: false,
            error: undefined,
            state: {
                dauToday: dauToday,
                dauThisWeek: dauThisWeek,
                newUsersToday: newUsersToday,
                newUsersThisWeek: newUsersThisWeek,
                totalUsers: totalUsers
            }
        };
    }
    else {
        return {
            isError: true,
            error: dashboardFeatureState.error,
            state: undefined
        };
    }
};
const updateNewStateDataWith = (data, projectDashboardFeatureState) => {
    data.stats = calculateStatsFeatureState(projectDashboardFeatureState);
    data.activeUsers = (0, exports.calculateActiveUsersFeatureState)(projectDashboardFeatureState);
    data.newUsers = (0, exports.calculateNewUsersFeatureState)(projectDashboardFeatureState);
};
exports.dashboardRetentionChunksParameters = {
    periodType: CommonTypesConversions_1.CommonTypesConversions.periodType.fromLastNDays(DashboardConstants_1.DASHBOARD_LAST_N_DAYS),
    retentionType: { nDay: {} },
    cohortQuery: [{ newUser: null }],
    returnQuery: [{ session: null }]
};
exports.dashboardStickinessChunksParameters = {
    periodType: CommonTypesConversions_1.CommonTypesConversions.periodType.fromLastNDays(DashboardConstants_1.DASHBOARD_LAST_N_DAYS),
    lineType: LineTypeJSONModel_1.LineType.nonCumulative,
    cohortQuery: [{ session: null }],
    returnQuery: [{ session: null }]
};
const ProjectDashboardDataProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const fetchDashboardQueryCalls = (0, react_1.useCallback)(async (projectApiKey) => {
        const get = async () => {
            setStateQueryCalls({ inProgress: true });
            try {
                const actorResult = await projectsContext.getActor(projectApiKey);
                if (!lodash_1.default.isNil(actorResult.error)) {
                    console.warn("fetchDashboardQueryCalls failed", actorResult.error);
                    setStateQueryCalls({
                        inProgress: false,
                        error: actorResult.error,
                        isError: true,
                    });
                }
                else {
                    // console.log("fetchDashboard with", _.map(actorResult.actors, v => Actor.canisterIdOf(v).toText()));
                    const promises = [
                        (0, DashboardApiService_1.getProjectDashboardResultByChunks)(actorResult.actors, actorResult.accessToken, DashboardConstants_1.DASHBOARD_LAST_N_DAYS),
                        (0, LifecycleApiService_1.getProjectLifecycleResultByChunks)(actorResult.actors, actorResult.accessToken, DashboardConstants_1.DASHBOARD_LAST_N_DAYS, LifecycleGranularityJSONModel_1.defaultLifecycleGranularity),
                        (0, StickinessApiService_1.getProjectStickinessResultByChunks)(actorResult.actors, actorResult.accessToken, exports.dashboardStickinessChunksParameters),
                        (0, EventApiService_1.getProjectDashboardEvents)(actorResult.actors, actorResult.accessToken, DashboardConstants_1.DASHBOARD_LAST_N_DAYS, AggregationJSONModel_1.Aggregation.dau),
                    ];
                    const promiseAllSettledResult = await Promise.allSettled(promises);
                    let projectDashboardFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)(promiseAllSettledResult[0]);
                    let projectLifecycleWeekFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)(promiseAllSettledResult[1]);
                    let projectStickinessWeekDataProviderCommonState = (0, DataProviderCommonTypes_1.getDataProviderCommonStateFromSettledPromiseResult)(promiseAllSettledResult[2]);
                    let projectEventsDayFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)(promiseAllSettledResult[3]);
                    // const eventsPercentFromDAU: Array<DashboardEventData> | undefined = eventsUniquesPercentFromDAU(projectEventsDayFeatureState.state?.uniques, projectDashboardFeatureState.state?.dau)
                    if (isFakeData) {
                        projectDashboardFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)({ status: "fulfilled", value: { ok: exports.testDashboardData } });
                        projectLifecycleWeekFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)({ status: "fulfilled", value: { ok: testLifecycleDataDaily } });
                        projectStickinessWeekDataProviderCommonState = (0, DataProviderCommonTypes_1.getDataProviderCommonStateFromSettledPromiseResult)({ status: "fulfilled", value: { ok: exports.D_Stickiness } });
                        projectStickinessWeekDataProviderCommonState.data = (0, StickinessApiService_1.addCohortToChartData)(projectStickinessWeekDataProviderCommonState.data);
                    }
                    const isGlobalError = projectDashboardFeatureState.isError && projectLifecycleWeekFeatureState.isError;
                    const newState = {
                        inProgress: false,
                        loaded: true,
                        isError: isGlobalError,
                        error: isGlobalError ? new Error("API error") : undefined,
                        data: {
                            lifecycle: projectLifecycleWeekFeatureState,
                            stickiness: projectStickinessWeekDataProviderCommonState,
                            events: projectEventsDayFeatureState,
                        }
                    };
                    if (newState.data) {
                        updateNewStateDataWith(newState.data, projectDashboardFeatureState);
                    }
                    setStateQueryCalls(newState);
                }
            }
            catch (e) {
                console.warn("fetchDashboardQueryCalls failed", e);
                setStateQueryCalls({
                    inProgress: false,
                    error: e,
                    isError: true,
                });
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted]);
    const fetchDashboardUpdateCalls = (0, react_1.useCallback)(async (projectApiKey) => {
        const get = async () => {
            setStateUpdateCalls({ inProgress: true });
            try {
                const actorResult = await projectsContext.getActor(projectApiKey);
                if (!lodash_1.default.isNil(actorResult.error)) {
                    console.warn("fetchDashboardUpdateCalls failed", actorResult.error);
                    setStateUpdateCalls({
                        inProgress: false,
                        error: actorResult.error,
                        isError: true,
                    });
                }
                else {
                    // console.log("fetchDashboard with", _.map(actorResult.actors, v => Actor.canisterIdOf(v).toText()));
                    const promises = [
                        (0, RetentionApiService_1.getProjectRetentionResultByChunks)(actorResult.actors, actorResult.accessToken, exports.dashboardRetentionChunksParameters),
                    ];
                    const promiseAllSettledResult = await Promise.allSettled(promises);
                    let projectRetentionResultByChunksDataProviderCommonState = (0, DataProviderCommonTypes_1.getDataProviderCommonStateFromSettledPromiseResult)(promiseAllSettledResult[0]);
                    // const eventsPercentFromDAU: Array<DashboardEventData> | undefined = eventsUniquesPercentFromDAU(projectEventsDayFeatureState.state?.uniques, projectDashboardFeatureState.state?.dau)
                    if (isFakeData) {
                        projectRetentionResultByChunksDataProviderCommonState = (0, DataProviderCommonTypes_1.getDataProviderCommonStateFromSettledPromiseResult)({ status: "fulfilled", value: { ok: testRetentionData } });
                    }
                    const isGlobalError = projectRetentionResultByChunksDataProviderCommonState.isError;
                    const newState = {
                        inProgress: false,
                        loaded: true,
                        isError: isGlobalError,
                        error: isGlobalError ? new Error("API error") : undefined,
                        data: {
                            retention: projectRetentionResultByChunksDataProviderCommonState,
                        }
                    };
                    setStateUpdateCalls(newState);
                }
            }
            catch (e) {
                console.warn("fetchDashboardUpdateCalls failed", e);
                setStateUpdateCalls({
                    inProgress: false,
                    error: e,
                    isError: true,
                });
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted]);
    const [stateQueryCalls, setStateQueryCalls] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(initialState));
    const [stateUpdateCalls, setStateUpdateCalls] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(initialState));
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        stateQueryCalls,
        stateUpdateCalls,
        fetchDashboardQueryCalls,
        fetchDashboardUpdateCalls,
    }), [
        stateQueryCalls,
        stateUpdateCalls,
        fetchDashboardQueryCalls,
        fetchDashboardUpdateCalls,
    ], lodash_1.default.isEqual);
    return React.createElement(CurrentProjectDataContext.Provider, { value: value }, props.children);
};
exports.ProjectDashboardDataProvider = ProjectDashboardDataProvider;
